import { render, staticRenderFns } from "./CodeBoxDialog.vue?vue&type=template&id=7bb3da5a&"
import script from "./CodeBoxDialog.vue?vue&type=script&lang=ts&"
export * from "./CodeBoxDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CodeBoxDialog.vue?vue&type=style&index=0&id=7bb3da5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports